import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

function HeroWorldImage() {
  return (
    <div className="relative w-full lg:max-w-[780px] lg:translate-x-24">
      <div className="lg:[transform:perspective(1400px)_rotateY(-8deg)_rotateX(2deg)] lg:origin-right">
        <video
          autoPlay
          loop
          muted
          playsInline
          preload="auto"
          poster="/assets/images/home/hero-route-map.webp"
          className="w-full h-auto rounded-2xl object-cover lg:scale-[1.14] lg:origin-right"
          style={{
            border: '1px solid var(--border2)',
            boxShadow: '0 32px 80px rgba(0,0,0,0.32)',
          }}
        >
          <source src="/world-video.mp4" type="video/mp4" />
          <source src="/world-image.webm" type="video/webm" />
        </video>
      </div>
    </div>
  );
}

export default function HeroSection() {
  const [vis, setVis] = useState(false);

  useEffect(() => {
    const t = setTimeout(() => setVis(true), 150);
    return () => clearTimeout(t);
  }, []);

  const anim = () =>
    `transition-all duration-700 ease-out ${vis ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`;

  return (
    <section
      className="relative min-h-screen flex items-center overflow-hidden glow-bg"
      style={{ paddingTop: 140, paddingBottom: 80, background: 'var(--bg)' }}
    >
      {/* Animated mesh background */}
      <div className="absolute inset-0 pointer-events-none">
        <div
          style={{
            position: 'absolute', inset: 0,
            background: `
              radial-gradient(ellipse 80% 60% at 70% 20%, rgba(232,97,26,0.10) 0%, transparent 60%),
              radial-gradient(ellipse 60% 40% at 20% 80%, rgba(232,97,26,0.06) 0%, transparent 55%)
            `,
            animation: 'mesh 12s ease-in-out infinite',
          }}
        ></div>

        {/* Perspective grid floor */}
        <div
          style={{
            position: 'absolute',
            bottom: 0, left: '-20%', right: '-20%',
            height: '45%',
            backgroundImage: `linear-gradient(var(--grid-color) 1px, transparent 1px), linear-gradient(90deg, var(--grid-color) 1px, transparent 1px)`,
            backgroundSize: '50px 50px',
            transform: 'perspective(600px) rotateX(62deg)',
            transformOrigin: 'bottom',
            maskImage: 'linear-gradient(to top, rgba(0,0,0,0.6) 0%, transparent 80%)',
            WebkitMaskImage: 'linear-gradient(to top, rgba(0,0,0,0.6) 0%, transparent 80%)',
            animation: 'grid-pan 5s linear infinite',
          }}
        ></div>

        {/* Dot grid */}
        <div
          style={{
            position: 'absolute', inset: 0,
            backgroundImage: 'radial-gradient(var(--dot-color) 1px, transparent 1px)',
            backgroundSize: '40px 40px',
          }}
        ></div>
      </div>

      <div className="relative max-w-7xl mx-auto px-5 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-[0.8fr_1.2fr] gap-12 lg:gap-8 items-center">

          {/* LEFT */}
          <div>
            <div className={`${anim()} flex flex-col items-start gap-2`} style={{ transitionDelay: '0.1s', marginBottom: 20 }}>
              <div className="label">
                <div className="label-dot"></div>
                Türkiye&apos;den Dünyaya Lojistik
              </div>
              <div
                className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full"
                style={{ background: 'rgba(232,97,26,0.12)', border: '1px solid rgba(232,97,26,0.3)', fontSize: 12, fontWeight: 700, color: 'var(--orange)' }}
              >
                <i className="ri-flight-takeoff-line"></i>
                Havayolu Kargo Uzmanı
              </div>
            </div>

            <h1
              className={`${anim()} h-font leading-[0.95]`}
              style={{
                fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 'clamp(46px, 6vw, 82px)',
                color: 'var(--text1)', marginBottom: 24, transitionDelay: '0.2s',
              }}
            >
              Kargonuzu<br />
              Dünyayla<br />
              <span className="text-gradient">Buluşturun.</span>
            </h1>

            <p
              className={`${anim()} text-lg leading-relaxed`}
              style={{ color: 'var(--text2)', maxWidth: 440, marginBottom: 36, transitionDelay: '0.3s' }}
            >
              <strong style={{ color: 'var(--text1)' }}>Havayolu kargo</strong> uzmanlığıyla uluslararası ekspres teslimat, e-ticaret lojistiği ve fulfillment hizmetleriyle
              işletmenizi <strong style={{ color: 'var(--text1)' }}>200+ ülkeye</strong> taşıyoruz.
            </p>

            <div className={`${anim()} flex flex-wrap gap-3`} style={{ marginBottom: 48, transitionDelay: '0.4s' }}>
              <Link to="/iletisim" className="btn-primary">
                Ücretsiz Teklif Al <i className="ri-arrow-right-line bounce-x"></i>
              </Link>
              <Link to="/hizmetler" className="btn-ghost">
                Hizmetleri Keşfet
              </Link>
            </div>

            <div
              className={`${anim()} grid grid-cols-3 gap-5`}
              style={{ paddingTop: 28, borderTop: '1px solid var(--border)', transitionDelay: '0.5s' }}
            >
              {[
                { n: '200+', l: 'Ülkeye Teslimat', sub: 'Hava kargo ağı' },
                { n: '8400+', l: 'Aylık Gönderi', sub: 'Havayolu ekspres' },
                { n: '4600+', l: 'Fulfillment Dağıtım', sub: 'Aylık sipariş karşılama' },
              ].map((s) => (
                <div key={s.n}>
                  <div style={{ fontFamily: 'var(--font-h)', fontWeight: 800, fontSize: 28, color: 'var(--text1)', lineHeight: 1 }}>
                    {s.n}
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 13, color: 'var(--orange)', marginTop: 3 }}>{s.l}</div>
                  <div style={{ fontSize: 11, color: 'var(--text3)', marginTop: 1 }}>{s.sub}</div>
                </div>
              ))}
            </div>
          </div>

          {/* RIGHT — World image */}
          <div
            className={`${anim()} flex justify-center lg:justify-end pt-10 pb-10 pr-0 lg:pr-0`}
            style={{ transitionDelay: '0.4s' }}
          >
            <HeroWorldImage />
          </div>
        </div>

        {/* Bottom partner logos */}
        <div
          className={`${anim()} mt-16`}
          style={{ paddingTop: 28, borderTop: '1px solid var(--border)', transitionDelay: '0.7s' }}
        >
          <p style={{ fontSize: 11, fontWeight: 700, color: 'var(--text3)', letterSpacing: '0.12em', textTransform: 'uppercase', marginBottom: 16 }}>
            Entegre Marketplace&apos;ler
          </p>
          <div className="overflow-hidden">
            <div className="marquee-track flex gap-6 w-max">
              {['Amazon', 'Etsy', 'eBay', 'AliExpress', 'Zalando', 'Trendyol', 'n11', 'Hepsiburada',
                'Amazon', 'Etsy', 'eBay', 'AliExpress', 'Zalando', 'Trendyol', 'n11', 'Hepsiburada'].map((p, i) => (
                <div
                  key={i}
                  className="flex items-center gap-2 px-5 py-2 rounded-full whitespace-nowrap"
                  style={{ background: 'var(--surface)', border: '1px solid var(--border)', fontWeight: 700, fontSize: 13, color: 'var(--text2)' }}
                >
                  {p}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
